import { protectedRoutes, publicRoutes } from 'configs/RoutesConfig'
import {
  Navigate,
  Route,
  createBrowserRouter,
  createRoutesFromChildren,
} from 'react-router-dom'
import AppRoute from './AppRoute'
import ProtectedRoute from './ProtectedRoute'
import PublicRoute from './PublicRoute'
import AppLayout from 'layouts/AppLayout'
import AuthLayout from 'layouts/AuthLayout'
import InnerAppLayout from 'layouts/InnerAppLayout'
import SettingsMenu from 'views/app-views/settings/SettingsMenu'
import RootError from 'views/error-views/root-error'

const routes = createBrowserRouter(
  createRoutesFromChildren(
    <Route errorElement={<RootError />}>
      <Route element={<ProtectedRoute />}>
        <Route path="app" element={<AppLayout />}>
          <Route errorElement={<RootError />}>
            {protectedRoutes.app.map((route, index) => (
              <Route
                index={index === 0}
                key={index}
                path={route.path}
                element={
                  <AppRoute component={route.component} {...route.meta} />
                }
              />
            ))}

            <Route path="cards" element={<InnerAppLayout />}>
              {protectedRoutes.cards.map((route, index) => (
                <Route
                  index={index === 0}
                  key={index}
                  path={route.path}
                  element={
                    <AppRoute component={route.component} {...route.meta} />
                  }
                />
              ))}
            </Route>

            <Route path="vps" element={<InnerAppLayout />}>
              {protectedRoutes.vps.map((route, index) => (
                <Route
                  index={index === 0}
                  key={index}
                  path={route.path}
                  element={
                    <AppRoute component={route.component} {...route.meta} />
                  }
                />
              ))}
            </Route>

            <Route path="reverse-proxy" element={<InnerAppLayout />}>
              {protectedRoutes.reverseProxy.map((route, index) => (
                <Route
                  index={index === 0}
                  key={index}
                  path={route.path}
                  element={
                    <AppRoute component={route.component} {...route.meta} />
                  }
                />
              ))}
            </Route>

            <Route path="ticket" element={<InnerAppLayout />}>
              {protectedRoutes.support.map((route, index) => (
                <Route
                  index={index === 0}
                  key={index}
                  path={route.path}
                  element={
                    <AppRoute component={route.component} {...route.meta} />
                  }
                />
              ))}
            </Route>

            <Route path="wallet" element={<InnerAppLayout />}>
              {protectedRoutes.wallet.map((route, index) => (
                <Route
                  index
                  key={index}
                  path={route.path}
                  element={
                    <AppRoute component={route.component} {...route.meta} />
                  }
                />
              ))}
            </Route>

            <Route path="billing" element={<InnerAppLayout />}>
              {protectedRoutes.billing.map((route, index) => (
                <Route
                  index
                  key={index}
                  path={route.path}
                  element={
                    <AppRoute component={route.component} {...route.meta} />
                  }
                />
              ))}
            </Route>

            <Route path="billing/checkout">
              {protectedRoutes.checkout.map((route, index) => (
                <Route
                  index={index === 0}
                  key={index}
                  path={route.path}
                  element={
                    <AppRoute component={route.component} {...route.meta} />
                  }
                />
              ))}
            </Route>

            <Route
              path="settings"
              element={<InnerAppLayout sideContent={<SettingsMenu />} />}
            >
              {protectedRoutes.settings.map((route, index) => (
                <Route
                  index={index === 0}
                  key={index}
                  path={route.path}
                  element={
                    <AppRoute component={route.component} {...route.meta} />
                  }
                />
              ))}
            </Route>

            <Route path="domain" element={<InnerAppLayout />}>
              {protectedRoutes.domain.map((route, index) => (
                <Route
                  index={index === 0}
                  key={index}
                  path={route.path}
                  element={
                    <AppRoute component={route.component} {...route.meta} />
                  }
                />
              ))}
            </Route>

            <Route path="email" element={<InnerAppLayout />}>
              {protectedRoutes.email.map((route, index) => (
                <Route
                  index={index === 0}
                  key={index}
                  path={route.path}
                  element={
                    <AppRoute component={route.component} {...route.meta} />
                  }
                />
              ))}
            </Route>
            <Route path="automation" element={<InnerAppLayout />}>
              {protectedRoutes.automation.map((route, index) => (
                <Route
                  index={index === 0}
                  key={index}
                  path={route.path}
                  element={
                    <AppRoute component={route.component} {...route.meta} />
                  }
                />
              ))}
            </Route>
          </Route>
        </Route>
      </Route>
      <Route element={<PublicRoute />}>
        <Route path="auth" element={<AuthLayout />}>
          {publicRoutes.auth.map((route, index) => (
            <Route
              key={index}
              path={route.path}
              element={<AppRoute component={route.component} {...route.meta} />}
            />
          ))}
        </Route>
      </Route>
      <Route path="/" element={<Navigate to="app" replace />} />
    </Route>
  )
)

export default routes
